/**
 * Ably event carrying streaming-publish progress on the org channel.
 *
 * Ephemeral by design: nothing is persisted for it, and durable status still
 * comes from the `datasets` / `runs` rows. A client that misses a tick (a page
 * refresh, a reconnect) just falls back to the plain spinner until the next one.
 */
export const RUN_PROGRESS_EVENT = "run-progress";

/**
 * Payload of a {@link RUN_PROGRESS_EVENT} broadcast. `id` is the dataset id so
 * the event matches the shape every other org broadcast uses.
 *
 * Counters are absolute and monotonic — never a percentage, since the total is
 * unknown until the final row arrives.
 */
export interface RunProgressEvent {
  id: string;
  runId: string;
  /**
   * When the broadcasting run started, as epoch milliseconds. Two runs for the
   * same dataset can stream at once (a retried publish whose predecessor is
   * still transferring), and their ticks interleave on one channel; this is what
   * lets a receiver keep the newest one instead of alternating between them.
   */
  startedAt: number;
  /** Rows written to the Arrow stream so far. */
  rowCount: number;
  /** Bytes of Arrow IPC written to the GCS upload so far. */
  sizeBytes: number;
}
